<template>
  <div>
    <RadioGroup
      v-model="promoterConfig.userType"
      class="clear"
      @on-change="changeType"
    >
      <Radio :label="1">指定人员</Radio>
      <Radio :label="2">指定部门</Radio>
      <Radio :label="3">指定角色</Radio>
    </RadioGroup>
    <div class="promoterInfoSelect">
      <div v-show="promoterConfig.userType == 1">
        <Button
          :icon="personIsEdit ? 'ios-create' : 'md-add'"
          type="primary"
          @click="openPersonModal"
          >{{ personIsEdit ? '修改成员' : '添加成员' }}</Button
        >
        <a class="clearList" @click="clearList('person')">清空</a>
        <selectShowList :list="list.person" @on-delete-item="personDel" />
      </div>
      <div v-show="promoterConfig.userType == 2">
        <Button
          :icon="departmentIsEdit ? 'ios-create' : 'md-add'"
          type="primary"
          @click="openDepartmentModal"
          >{{ departmentIsEdit ? '修改部门' : '添加部门' }}</Button
        >
        <a class="clearList" @click="clearList('department')">清空</a>
        <selectShowList
          type="department"
          :list="list.department"
          @on-delete-item="departmentDel"
        />
      </div>
      <div v-show="promoterConfig.userType == 3">
        <Button
          :icon="roleIsEdit ? 'ios-create' : 'md-add'"
          type="primary"
          @click="openRoleModal"
          >{{ roleIsEdit ? '修改角色' : '添加角色' }}</Button
        >
        <a class="clearList" @click="clearList('role')">清空</a>
        <selectShowList :list="list.role" @on-delete-item="roleDel" />
      </div>
    </div>
  </div>
</template>
<script>
import selectShowList from './selectShowList.vue';
export default {
  name: 'promoterInfo',
  props: {
    list: {
      type: Object,
      default: () => ({})
    },
    promoterConfig: {
      type: Object,
      default: () => ({})
    }
  },
  components: { selectShowList },
  data() {
    return {};
  },
  computed: {
    personIsEdit() {
      return this.list.person && this.list.person.length > 0;
    },
    departmentIsEdit() {
      return this.list.department && this.list.department.length > 0;
    },
    roleIsEdit() {
      return this.list.role && this.list.role.length > 0;
    }
  },
  methods: {
    changeType() {
      // alert(111);
    },
    openPersonModal() {
      this.$emit('open-person-modal');
    },
    openDepartmentModal() {
      this.$emit('open-department-modal');
    },
    openRoleModal() {
      this.$emit('open-role-modal');
    },
    personDel(deleteItem) {
      const { id } = deleteItem;
      const personList = this.list.person;
      const newList = personList.filter(i => i.id != id);
      const list = { ...this.list, person: [...newList] };
      this.$emit('update:list', list);
    },
    departmentDel(deleteItem) {
      const { relationId } = deleteItem;
      const departmentList = this.list.department;
      const newList = departmentList.filter(i => i.relationId != relationId);
      const list = { ...this.list, department: [...newList] };
      this.$emit('update:list', list);
    },
    roleDel(deleteItem) {
      const { id } = deleteItem;
      const roleList = this.list.role;
      const newList = roleList.filter(i => i.id != id);
      const list = { ...this.list, role: [...newList] };
      this.$emit('update:list', list);
    },
    clearList(type) {
      const list = { ...this.list, [type]: [] };
      this.$emit('update:list', list);
    }
  }
};
</script>
<style lang="less" scoped>
.promoterInfoSelect {
  margin: 10px 0;
}
.clearList {
  margin: 0 10px;
}
</style>
